/**
 * ****************************************************************************
 * @description     :   Store for page MNG_SalesReport002
 * @package         :   Move
 * ****************************************************************************
 */

const MSG_NO_DATA = '該当するデータが存在しません。';

const createSchedule = () => ({
    no: '',
    start_date: '',
    name_person: '',
    filename: '',
    file: '',
    notes: ''
});

const createPlace = () => ({
    business_matters: [],
    report_items_contents1: '',
    reporting_filename: '',
    reporting_file: '',
    paginationData: {
        pageNo: 1,
        pageSize: 5,
        totalRows: 0,
        msgNoData: MSG_NO_DATA
    },
    visit_reports: []
});

const createInitialData = () => ({
    type: '1',
    office: '1',
    company_cd: '',
    company_name: '',
    md_name: '',
    mdcd: 0,
    work_report_id: 0,
    tab_no: 1,
    index_type: 1,
    branch_cd: '',
    branch_nm: '',
    visit_date: '',
    report_date: '',
    reporter_cd: '',
    reporter_nm: '',
    client_cd: '',
    client_nm: '',
    sales_note: '',
    business_matters: [],
    schedules: [createSchedule()],
    places: [createPlace()],
    report_items_contents1: '',
    reporting_filename: '',
    reporting_file: '',
    visit_reports: []
});

const createPagination = () => ({
    pageNo: 1,
    pageSize: 5,
    totalRows: 0,
    msgNoData: MSG_NO_DATA
});

export default {
    namespaced: true,
    state: {
        data: createInitialData(),
        paginationData: createPagination(),
        optionGroup: {
            type: [
                { code: 1, name: '現場' },
                { code: 2, name: 'オフィス' }
            ],
            office: [{ code: 1, name: '新宿' }],
            business_matters: [
                { code: 1, name: 'お客様登録書（紙面orQR）', note: '' },
                { code: 2, name: '業務委託基本契約書' },
                { code: 3, name: '請負基本料金表（A表・B表・OP・QR）', note: '' },
                { code: 4, name: 'TSR与信審査' },
                { code: 5, name: '請求・支払い方法（売掛・NP）' },
                { code: 6, name: '業務依頼書（個別契約書）※QR', note: '' },
                { code: 7, name: '営業事例説明' },
                { code: 8, name: '他社使用状況ヒアリング' }
            ],
            business_partners: [
                { code: 1, name: '名刺交換', note: '※後日、上長報告（eightに転記）' },
                { code: 2, name: '終了報告' }
            ],
            yes_no_option: [
                { code: 1, name: 'あり' },
                { code: 2, name: 'なし' }
            ],
            pageSize: [
                { code: 5, name: '5件' },
                { code: 10, name: '10件' },
                { code: 50, name: '50件' }
            ]
        }
    },
    mutations: {
        resetFormData(state, type) {
            state.data = createInitialData();
            state.data.type = type;
            state.paginationData = createPagination();
        },
        initForm(state, data) {
            state.data = JSON.parse(JSON.stringify(data || createInitialData()));
            const totalRows = state.data.visit_reports?.length || 0;
            state.paginationData = {
                pageNo: 1,
                pageSize: 5,
                totalRows,
                msgNoData: totalRows === 0 ? MSG_NO_DATA : ''
            };
        }
    },
    actions: {}
};
